export default {
  loading: false,
  resources: [],
  resource: null,
}
